import { showDeleteConfirmation } from "components/ApiKeys/DeleteConfirmation";
import { getPersonalApiKeyIssue } from "components/ApiKeys/PersonalApiKeys/helpers";
import usePersonalApiKeysState from "components/ApiKeys/PersonalApiKeys/usePersonalApiKeysState";
import { showResetConfirmation } from "components/ApiKeys/ResetConfirmation";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ApiKeyType } from "types/generated";

import { showPersonalSettingsApiKeysDetailsDrawer } from "../../DetailsDrawer";
import { showPersonalSettingsApiKeysEditDrawer } from "../../EditDrawer";
import { GET_PERSONAL_API_KEYS, PersonalApiKey } from "../../gql";

const REFETCH_QUERIES = [GET_PERSONAL_API_KEYS];

const PersonalApiKeysTableDropdownCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<PersonalApiKey>) => {
  const { enabled: isPersonalApiKeysEnabled } = usePersonalApiKeysState();

  const onEditDetailsClick = () => {
    showPersonalSettingsApiKeysEditDrawer({
      apiKey,
      refetchQueries: REFETCH_QUERIES,
    });
  };

  const onDetailsClick = () => {
    showPersonalSettingsApiKeysDetailsDrawer({
      id: apiKey.id,
      apiKey,
    });
  };

  const onResetClick = () => {
    showResetConfirmation({ name: apiKey.name, id: apiKey.id });
  };

  const onDeleteClick = () => {
    showDeleteConfirmation({
      name: apiKey.name,
      id: apiKey.id,
      refetchQueriesOnDelete: REFETCH_QUERIES,
    });
  };

  const hasIssue = !!getPersonalApiKeyIssue(apiKey);

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="API key actions">
        {!hasIssue && (
          <DropdownMenuItem onAction={onEditDetailsClick}>Edit details</DropdownMenuItem>
        )}
        <DropdownMenuItem onAction={onDetailsClick}>See details</DropdownMenuItem>
        {!hasIssue && isPersonalApiKeysEnabled && apiKey.type === ApiKeyType.Secret && (
          <DropdownMenuItem onAction={onResetClick}>Reset</DropdownMenuItem>
        )}
        <DropdownMenuItem onAction={onDeleteClick} danger>
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableDropdownCell;
